import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ellipsisText]',
  host: {
    'style': 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;'
  }
})
export class EllipsisTextDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  parentNode!: HTMLElement;
  collapsed = true;

  dotsEl = this.renderer.createElement('a');
  dotsText = this.renderer.createText('Read More');
  dotsIcon = this.renderer.createElement('i');

  constructor() {
    this.dotsEl.setAttribute('href', '');
    this.dotsEl.setAttribute('class', 'd-block text-end');
    this.renderer.appendChild(this.dotsEl, this.dotsText);

    this.toggleIcon();
  }

  ngAfterViewInit(): void {
    if (this.el.nativeElement.scrollWidth > this.el.nativeElement.offsetWidth) {
      this.addDots();
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeChild(this.el.nativeElement, this.dotsEl);
  }

  addDots() {
    this.renderer.listen(this.dotsEl, 'click', (event) => {
      event.preventDefault();

      this.toggleEllipsis();
    });
    
    this.renderer.appendChild(this.el.nativeElement, this.dotsEl);
  }

  toggleEllipsis() {
    if (this.collapsed) {
      this.el.nativeElement.style.whiteSpace = 'normal';
      this.dotsEl.innerText = 'Read Less';
    } else {
      this.el.nativeElement.style.whiteSpace = 'nowrap';
      this.dotsEl.innerText = 'Read More';  
    }

    this.collapsed = !this.collapsed;
    this.toggleIcon();
  }

  toggleIcon() {
    if(this.collapsed) {
      this.dotsIcon.setAttribute('class', 'fa-solid fa-angle-down');  
    } else {
      this.dotsIcon.setAttribute('class', 'fa-solid fa-angle-up');
    }

    this.renderer.appendChild(this.dotsEl, this.dotsIcon);
  }

}
